import dealerNoInvoiceFee from './dealer_no_invoice_fee.vue';

export default dealerNoInvoiceFee;
